import Icon from '@mui/icons-material/SettingsOutlined';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function SettingsIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
